export function schemaValidatorWrapper(fun: () => void): void {
  // API schema validation is not a critical task so we should
  // avoid blocking the main thread by using the requestIdleCallback
  // safari doesn't support requestIdleCallback
  // @ts-ignore
  if (window.requestIdleCallback) {
    // @ts-ignore
    window.requestIdleCallback(fun);
  } else {
    // fall back to setTimeout if the current browser doesn't support requestIdleCallback
    // we don't use promise here because promise register a microtask
    // which have higher priority and block the other microtask
    setTimeout(fun, 0);
  }
}
